<div *ngIf="fetching" class="fetching-files">
    <mat-spinner></mat-spinner>
</div>
<div class="shareholders-container" id="shareholders-container">
    <ng-container *ngTemplateOutlet="selectedShareholderId ? singleShareholder : mutipleShareholders"></ng-container>
</div>

<ng-template #mutipleShareholders>
    <div class="header-bar" id="header-bar">
        <div class="header-text-div">
            <span class="header-text" id="header-text">Shareholders</span>
        </div>
    </div>
    <div class="main">
        <div class="search-bar" id="search-bar">
            <app-user-access-search
                [initialValue]="searchValue"
                (newSearchEvent)="performSearch($event)"
                data-testid="app-accounts-search"
                placeholder="Filter by name"
            ></app-user-access-search>
        </div>
        <div class="table-container">
            <app-shareholder-table
                (pageEvent)="handlePageEvent($event)"
                (sortEvent)="handleSortChange($event)"
                [fetching]="fetching"
                [initialSort]="{ id: requestHelper.sortField, start: requestHelper.sortDir }"
                [pageSize]="pageSize"
                [page]="page"
                [searchText]="searchValue"
                [shareholderRecords]="shareholderRecords"
                [totalRecords]="totalRecords"
                class="shareholders-table"
                data-testid="app-shareholders-table"
            ></app-shareholder-table>
        </div>
    </div>
</ng-template>

<ng-template #singleShareholder>
    <ng-container *ngTemplateOutlet="showCreateEditUser ? createUserForm : null"> </ng-container>
    <div *ngIf="!showCreateEditUser" class="wrapper-div">
        <div class="page-title-actions">
            <div class="title-actions">
                <span class="title">{{ selectedShareholder?.shareholder }}</span>
                <div class="actions">
                    <app-button
                        (clicked)="shareholderActivityClick()"
                        label="Shareholder Activity"
                        buttonClass="secondary"
                        data-testid="shareholder-activity-button"
                    />
                </div>
            </div>
        </div>
        <div class="frame-div">
            <div class="shareholder-details-div">
                <div class="shareholder-details-scroll">
                    <div class="info-div">
                        <div class="info-label">SHAREHOLDER INFO</div>
                        <div class="info-data">
                            <span class="info-data-label">Shareholder Email</span>
                            <span class="info-data-value">{{ selectedShareholder?.email }}</span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">NetSuite ID</span>
                            <span
                                class="as-link"
                                (click)="openInNewTab($event, getShareholderNsUrl(selectedShareholder?.nsId))"
                                [matTooltip]="getShareholderNsUrl(selectedShareholder?.nsId)"
                                matTooltipPosition="below"
                                matTooltipShowDelay="300"
                                matTooltipHideDelay="200"
                                >{{ selectedShareholder?.nsId }}
                            </span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Subsidiary</span>
                            <span class="info-data-value" *ngFor="let sub of selectedShareholder?.subsidiaries">{{
                                sub
                            }}</span>
                        </div>
                        <div class="info-data">
                            <span class="info-data-label">Address</span>
                            <span class="info-data-value">{{ selectedShareholder?.address1 }}</span>
                            <span class="info-data-value">{{ selectedShareholder?.address2 }}</span>
                            <span class="info-data-value">{{ selectedShareholder?.address3 }}</span>
                            <span class="info-data-value">{{ selectedShareholder?.address4 }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="deals-users-section-div">
                <div class="deals-users-frame-div">
                    <div class="deals-users-search-bar">
                        <app-user-access-search
                            [initialValue]="searchValue"
                            data-testid="app-accounts-search-users"
                            placeholder="Filter by deal, user, or role..."
                            (newSearchEvent)="performSearchShareholderUserAccess($event)"
                        >
                        </app-user-access-search>
                    </div>
                </div>
                <div class="table-container">
                    <app-shareholder-user-access-table
                        class="deals-users-table"
                        data-testid="app-deal-user-table"
                        [displayedColumns]="displayedColumns"
                        [records]="shareholderUserAccessRecords"
                        [searchText]="searchValueShareholderUserAccess"
                        [initialSort]="{
                            id: requestHelperShareholderUserAccess.sortField,
                            start: requestHelperShareholderUserAccess.sortDir
                        }"
                        [page]="pageShareholderUserAccess"
                        [pageSize]="pageSizeShareholderUserAccess"
                        [totalRecords]="totalRecordsShareholderUserAccess"
                        [fetching]="fetchingShareholderUserAccess"
                        [showRevokeAccess]="showRevokeAccess"
                        [showImpersonateUser]="showImpersonateUser"
                        (pageEvent)="handlePageEventShareholderUserAccess($event)"
                        (sortEvent)="handleSortChangeShareholderUserAccess($event)"
                        (revokeAccessEvent)="handleRevokeAccessEvent($event)"
                        (userClickedEvent)="handleUserClickedEvent($event)"
                        (dealClickedEvent)="handleDealClickedEvent($event)"
                        (editUserEvent)="handleEditUserEvent($event)"
                    ></app-shareholder-user-access-table>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #createUserForm>
    <app-create-edit-user
        id="create-edit-user"
        [mode]="createEditUserMode"
        [userToEditId]="userToEditId"
        (showCreateEditUserCloseEvent)="handleShowCreateEditUserCancelEvent()"
    ></app-create-edit-user>
</ng-template>
